import React, { useState } from 'react';

import PostData from '../../services/PostData.js'
import useApiData from "../../services/useApiData.js"
import SnackbarEx from '../Helpers/SnackbarEx.jsx';
import { Button, TextField, Autocomplete, Chip, Typography, Dialog } from "@mui/material";
import AddNewDescription from './AddNewDescription.jsx';

export default function ListingDescriptions() {
    const [submitLoad, setSubmitLoad] = useState(false)
    const [openAddNewDialog, setOpenAddNewDialog] = useState(false)
    const [description, setDescription] = useState({
        template: null,
        description: ""
    })

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })

    // const ebayDescriptions = ["Best By", "Purple", "Amazon", "Bust Lot", "Retail / Modified Packaging", "Casper / Tempur"]
    const { data: ebayDescripts, error: descriptionError, isLoading: loadDescriptins, refetch: refetchDescriptions } = useApiData("api/broylesllc/get-ebay-descriptions");

    const submitUpdate = async () => {
        setSubmitLoad(true)
        const { success, error: postError, load: postLoad } = await PostData(description, "broylesllc/update-ebay-descriptions", null)

        if (success) {
            setSubmitLoad(false)
            refetchDescriptions()
            setOpenTestSnack({ color: "success", message: "Saved successfully.", open: true })
        }
    }

    const selectTemplate = (e, newVal, reason) => {
        const newName = newVal?.templateName
        const findDescription = ebayDescripts?.find(v => v.templateName === newName)

        if (reason === "clear") { return setDescription({ ...description, ["template"]: null, ["description"]: "" }) }
        setDescription({ ...description, ["template"]: newName, ["description"]: findDescription?.description ?? "" })
    }


    return (
        <>
            <div style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                // paddingTop: "20px",
                padding: "10px 10px 0 10px",
                boxSizing: 'border-box'
            }}>
                {/* <div style={{ marginBottom: '10px' }}>
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 700, color: '#101828', fontSize: '18px !important' }}>
                        Update eBay Listing Description:
                    </Typography>
                </div> */}
                <div className="card-header bg-white"
                    style={{ borderBottom: '1px solid #f0f0f0' }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                        <Typography variant="h5" component="h1">
                            Update eBay Listing Description:
                        </Typography>
                        <Button
                            disableElevation
                            variant='outlined'
                            onClick={() => setOpenAddNewDialog(true)}
                        >
                            Add Description
                        </Button>
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    flex: 1,
                    minHeight: 0,
                    padding: '5px 20px'
                }}>
                    <Autocomplete
                        size='small'
                        loading={loadDescriptins}
                        options={ebayDescripts || []}
                        getOptionLabel={o => o?.templateName}
                        value={
                            description.template
                                ? ebayDescripts?.find(d => d.templateName === description.template) || description.template
                                : null
                        }
                        onChange={(e, val, reason) => selectTemplate(e, val, reason)}
                        onInputChange={(event, newInputValue) => {
                            setDescription(prev => ({
                                ...prev,
                                template: newInputValue
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Listing Description"}
                                sx={{
                                    width: '60%', borderRadius: '5px', minWidth: '300px',
                                    backgroundColor: '#fcfcfc'
                                }}
                            />
                        )}
                        sx={{ marginTop: '10px' }}
                    />

                    <TextField
                        label="Description"
                        // helperText={"Add the description HTML"}
                        multiline
                        size="small"
                        value={description.description}
                        onChange={(e) => setDescription({ ...description, ['description']: e.target.value })}
                        minRows={11}
                        error={description?.description.length > 4000}
                        helperText={
                            description?.description.length > 4000
                                ? `Description is over eBay's 4000 characters title limit .. current length: ${description?.description.length}`
                                : "Add the description HTML"
                        }
                        sx={{
                            flexGrow: 1,
                            '& .MuiInputBase-root': {
                                height: '350px',
                                alignItems: 'flex-start',
                                overflow: 'hidden',
                            },
                            '& .MuiInputBase-input': {
                                height: '100% !important',
                                overflow: 'auto !important',
                            }

                        }}
                    />
                </div>

                {/* Footer remains at the bottom */}
                <div className='card-footer' style={{
                    padding: '16px 0',
                    borderTop: '1px solid #e0e0e0',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    background: 'white'
                }}>
                    <Button
                        variant="contained"
                        onClick={submitUpdate}
                        loading={submitLoad}
                        sx={{ backgroundColor: '#3E5C76', width: '200px' }}
                    >
                        Save
                    </Button>
                </div>
            </div>
            <Dialog maxWidth={'sm'} fullWidth open={openAddNewDialog} onClose={() => setOpenAddNewDialog(false)}>
                <AddNewDescription close={() => setOpenAddNewDialog(false)} />
            </Dialog>
            {
                openTestSnack.open && <SnackbarEx
                    color={openTestSnack.color}
                    // position="top"
                    message={openTestSnack.message}
                    open={openTestSnack.open}
                    close={() => setOpenTestSnack({
                        color: "",
                        message: "",
                        open: false
                    })} />
            }
        </>
    );
};